/* istanbul ignore file */
import React, { useEffect, useRef } from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { displayQRCode } from '..';

const QRWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

const removeChildren = (divRef) => {
    if (divRef.current) {
        while (divRef.current.firstChild) {
            divRef.current.removeChild(divRef.current.firstChild);
        }
    }
};

const QRCode = ({ producttype: productType }) => {
    const qrWrapper = useRef(null);
    const qrWrapperId = useRef(`qrcode-wrapper-${uuidv4()}`);

    useEffect(() => {
        const observer = new MutationObserver((_, obs) => {
            /* istanbul ignore next */
            if (window.AF_SMART_SCRIPT) {
                removeChildren(qrWrapper);
                displayQRCode(qrWrapperId.current, uuidv4(), productType);
                obs.disconnect();
            }
        });

        observer.observe(document, {
            childList: true,
            subtree: true
        });

        return () => observer.disconnect();
    }, [productType]);

    return (
        <QRWrapper
            ref={qrWrapper}
            id={qrWrapperId.current}
            data-testid={qrWrapperId.current}
        />
    );
};

QRCode.propTypes = {
    producttype: string
};

export default QRCode;
